import { SegmentStrategy } from "../rules/intoSegments";
import { RuleSet } from "../rules/ruleSet";

/** attempt to pronounce English, an imperfect-but-better-than-nothing fallback when a word isn't in the dictionary */
export const englishToIpa: RuleSet = {
  preprocess: ['lowerCase', 'cleanPunctuation', 'cleanLigatures'],
  inputSegments: SegmentStrategy.Single,
  outputSegments: SegmentStrategy.Ipa,
  rules: [
    // remove some non-letters
    { from: '-', to: '' }, { from: '_', to: '' },
    { from: "'", to: '' }, { from: '"', to: '' }, { from: '`', to: '' },
    { from: '(', to: '' }, { from: ')', to: '' },
    { from: '[', to: '' }, { from: ']', to: '' },
    { from: '{', to: '' }, { from: '}', to: '' },

    // simply pronounce some non-letters
    { from: '0', to: 'ˈziɹoʊ̯' }, { from: '1', to: 'ˈwən' },
    { from: '2', to: 'ˈtu' }, { from: '3', to: 'ˈθɹi' },
    { from: '4', to: 'ˈfɔɹ' }, { from: '5', to: 'ˈfaɪ̯v' },
    { from: '6', to: 'ˈsɪks' }, { from: '7', to: 'ˈsɛvən' },
    { from: '8', to: 'ˈeɪ̯t' }, { from: '9', to: 'ˈnaɪ̯n' },
    { from: '.', to: 'dɑt' }, { from: '/', to: 'sɫæʃ' }, { from: '\\', to: 'ˈbækˌsɫæʃ' },
    { from: '@', to: 'æt' }, { from: '%', to: 'pɝˈsɛnt' },
    { from: '#', to: 'ˈhæʃˌtæɡ' }, { from: '&', to: 'ænd' },
    { from: '*', to: 'ˈstɑɹ' }, { from: '+', to: 'ˈpɫəs' },
    { from: '$', to: 'ˈdɑɫɝ' }, { from: '°', to: 'dɪˈɡɹiz' },
    { from: '>', to: 'ˈɡɹeɪtɝˌðæn' }, { from: '<', to: 'ˈɫɛsˌðæn' },
    { from: '|', to: 'ɔɹ' },
    // and symbols
    { from: "α", to: "/ˈæɫfə/" }, { from: "β", to: "/ˈbeɪtə/" }, { from: "γ", to: "/ˈɡæmə/" },
    { from: "δ", to: "/ˈdɛɫtə/" }, { from: "π", to: "/ˈpaɪ/" }, { from: "ω", to: "/oʊˈmɛɡə/" },
    { from: "ℵ", to: "/ˈeɪɫɨf/" },

    // soften before changing vowels
    { from: 'c', to: 's', next: { or: ['/e/', '/i/', '/y/'] } },
    { from: 'dge', to: 'd͡ʒ', next: ['#word'] },
    { from: 'g', to: 'd͡ʒ', previous: { not: '/g/' }, next: { or: ['/e/', '/i/', '/y/'] } },

    // special handling of VCed & VCes (but currently not VVCeX)
    { from: 'abed', to: 'eɪ̯bd', next: ['#word'] },
    { from: 'abes', to: 'eɪ̯bz', next: ['#word'] },
    { from: 'aced', to: 'eɪ̯st', next: ['#word'] },
    { from: 'aces', to: 'eɪ̯sɪz', next: ['#word'] },
    { from: 'aded', to: 'eɪ̯dɪd', next: ['#word'] },
    { from: 'ades', to: 'eɪ̯dz', next: ['#word'] },
    { from: 'afed', to: 'eɪ̯ft', next: ['#word'] },
    { from: 'afes', to: 'eɪ̯fs', next: ['#word'] },
    { from: 'aged', to: 'eɪ̯d͡ʒd', next: ['#word'] },
    { from: 'ages', to: 'eɪ̯d͡ʒɪz', next: ['#word'] },
    { from: 'ajed', to: 'eɪ̯d͡ʒd', next: ['#word'] },
    { from: 'ajes', to: 'eɪ̯d͡ʒɪz', next: ['#word'] },
    { from: 'aked', to: 'eɪ̯kt', next: ['#word'] },
    { from: 'akes', to: 'eɪ̯ks', next: ['#word'] },
    { from: 'aled', to: 'eɪ̯ɫd', next: ['#word'] },
    { from: 'ales', to: 'eɪ̯ɫz', next: ['#word'] },
    { from: 'amed', to: 'eɪ̯md', next: ['#word'] },
    { from: 'ames', to: 'eɪ̯mz', next: ['#word'] },
    { from: 'aned', to: 'eɪ̯nd', next: ['#word'] },
    { from: 'anes', to: 'eɪ̯nz', next: ['#word'] },
    { from: 'aped', to: 'eɪ̯pt', next: ['#word'] },
    { from: 'apes', to: 'eɪ̯ps', next: ['#word'] },
    { from: 'ared', to: 'ɛːɹd', next: ['#word'] },
    { from: 'ares', to: 'ɛːɹz', next: ['#word'] },
    { from: 'ased', to: 'eɪ̯st', next: ['#word'] },
    { from: 'ases', to: 'eɪ̯sɪs', next: ['#word'] },
    { from: 'ated', to: 'eɪ̯tɪd', next: ['#word'] },
    { from: 'ates', to: 'eɪ̯ts', next: ['#word'] },
    { from: 'aved', to: 'eɪ̯vd', next: ['#word'] },
    { from: 'aves', to: 'eɪ̯vz', next: ['#word'] },
    { from: 'awed', to: 'ɑd', next: ['#word'] },
    { from: 'awes', to: 'ɑz', next: ['#word'] },
    { from: 'axed', to: 'ækst', next: ['#word'] },
    { from: 'axes', to: 'æksɪz', next: ['#word'] },
    { from: 'azed', to: 'eɪ̯zd', next: ['#word'] },
    { from: 'azes', to: 'eɪ̯zɪz', next: ['#word'] },
    // e -> i
    { from: 'ebed', to: 'ibd', next: ['#word'] },
    { from: 'ebes', to: 'ibz', next: ['#word'] },
    { from: 'eced', to: 'ist', next: ['#word'] },
    { from: 'eces', to: 'isɪz', next: ['#word'] },
    { from: 'eded', to: 'idɪd', next: ['#word'] },
    { from: 'edes', to: 'idz', next: ['#word'] },
    { from: 'efed', to: 'ift', next: ['#word'] },
    { from: 'efes', to: 'ifs', next: ['#word'] },
    { from: 'eged', to: 'id͡ʒɪd', next: ['#word'] },
    { from: 'eges', to: 'id͡ʒɪz', next: ['#word'] },
    { from: 'ejed', to: 'id͡ʒɪd', next: ['#word'] },
    { from: 'ejes', to: 'id͡ʒɪz', next: ['#word'] },
    { from: 'eked', to: 'ikt', next: ['#word'] },
    { from: 'ekes', to: 'iks', next: ['#word'] },
    { from: 'eled', to: 'iɫd', next: ['#word'] },
    { from: 'eles', to: 'iɫz', next: ['#word'] },
    { from: 'emed', to: 'imd', next: ['#word'] },
    { from: 'emes', to: 'imz', next: ['#word'] },
    { from: 'ened', to: 'ind', next: ['#word'] },
    { from: 'enes', to: 'inz', next: ['#word'] },
    { from: 'eped', to: 'ipt', next: ['#word'] },
    { from: 'epes', to: 'ips', next: ['#word'] },
    { from: 'ered', to: 'iɹd', next: ['#word'] },
    { from: 'eres', to: 'iɹz', next: ['#word'] },
    { from: 'esed', to: 'ist', next: ['#word'] },
    { from: 'eses', to: 'isɪs', next: ['#word'] },
    { from: 'eted', to: 'itɪd', next: ['#word'] },
    { from: 'etes', to: 'its', next: ['#word'] },
    { from: 'eved', to: 'ivd', next: ['#word'] },
    { from: 'eves', to: 'ivz', next: ['#word'] },
    { from: 'exed', to: 'ikst', next: ['#word'] },
    { from: 'exes', to: 'iksɪz', next: ['#word'] },
    { from: 'ezed', to: 'izd', next: ['#word'] },
    { from: 'ezes', to: 'izɪz', next: ['#word'] },
    // i -> aɪ̯
    { from: 'ibed', to: 'aɪ̯bd', next: ['#word'] },
    { from: 'ibes', to: 'aɪ̯bz', next: ['#word'] },
    { from: 'iced', to: 'aɪ̯st', next: ['#word'] },
    { from: 'ices', to: 'aɪ̯sɪz', next: ['#word'] },
    { from: 'ided', to: 'aɪ̯dɪd', next: ['#word'] },
    { from: 'ides', to: 'aɪ̯dz', next: ['#word'] },
    { from: 'ifed', to: 'aɪ̯ft', next: ['#word'] },
    { from: 'ifes', to: 'aɪ̯fs', next: ['#word'] },
    { from: 'iged', to: 'aɪ̯d͡ʒd', next: ['#word'] },
    { from: 'iges', to: 'aɪ̯d͡ʒɪz', next: ['#word'] },
    { from: 'ijed', to: 'aɪ̯d͡ʒd', next: ['#word'] },
    { from: 'ijes', to: 'aɪ̯d͡ʒɪz', next: ['#word'] },
    { from: 'iked', to: 'aɪ̯kt', next: ['#word'] },
    { from: 'ikes', to: 'aɪ̯ks', next: ['#word'] },
    { from: 'iled', to: 'aɪ̯ɫd', next: ['#word'] },
    { from: 'iles', to: 'aɪ̯ɫz', next: ['#word'] },
    { from: 'imed', to: 'aɪ̯md', next: ['#word'] },
    { from: 'imes', to: 'aɪ̯mz', next: ['#word'] },
    { from: 'ined', to: 'aɪ̯nd', next: ['#word'] },
    { from: 'ines', to: 'aɪ̯nz', next: ['#word'] },
    { from: 'iped', to: 'aɪ̯pt', next: ['#word'] },
    { from: 'ipes', to: 'aɪ̯ps', next: ['#word'] },
    { from: 'ired', to: 'aɪ̯ɝd', next: ['#word'] },
    { from: 'ires', to: 'aɪ̯ɝz', next: ['#word'] },
    { from: 'ised', to: 'aɪ̯st', next: ['#word'] },
    { from: 'ises', to: 'aɪ̯sɪz', next: ['#word'] },
    { from: 'ited', to: 'aɪ̯tɪd', next: ['#word'] },
    { from: 'ites', to: 'aɪ̯ts', next: ['#word'] },
    { from: 'ived', to: 'aɪ̯vd', next: ['#word'] },
    { from: 'ives', to: 'aɪ̯vz', next: ['#word'] },
    { from: 'ixed', to: 'ɪkst', next: ['#word'] },
    { from: 'ixes', to: 'ɪksɪz', next: ['#word'] },
    { from: 'ized', to: 'aɪ̯zd', next: ['#word'] },
    { from: 'izes', to: 'aɪ̯zɪz', next: ['#word'] },
    // o -> oʊ̯
    { from: 'obed', to: 'oʊ̯bd', next: ['#word'] },
    { from: 'obes', to: 'oʊ̯bz', next: ['#word'] },
    { from: 'oced', to: 'oʊ̯st', next: ['#word'] },
    { from: 'oces', to: 'oʊ̯sɪz', next: ['#word'] },
    { from: 'oded', to: 'oʊ̯dɪd', next: ['#word'] },
    { from: 'odes', to: 'oʊ̯dz', next: ['#word'] },
    { from: 'ofed', to: 'oʊ̯ft', next: ['#word'] },
    { from: 'ofes', to: 'oʊ̯fs', next: ['#word'] },
    { from: 'oged', to: 'oʊ̯d͡ʒd', next: ['#word'] },
    { from: 'oges', to: 'oʊ̯d͡ʒɪz', next: ['#word'] },
    { from: 'ojed', to: 'oʊ̯d͡ʒd', next: ['#word'] },
    { from: 'ojes', to: 'oʊ̯d͡ʒɪz', next: ['#word'] },
    { from: 'oked', to: 'oʊ̯kt', next: ['#word'] },
    { from: 'okes', to: 'oʊ̯ks', next: ['#word'] },
    { from: 'oled', to: 'oʊ̯ɫd', next: ['#word'] },
    { from: 'oles', to: 'oʊ̯ɫz', next: ['#word'] },
    { from: 'omed', to: 'oʊ̯md', next: ['#word'] },
    { from: 'omes', to: 'oʊ̯mz', next: ['#word'] },
    { from: 'oned', to: 'oʊ̯nd', next: ['#word'] },
    { from: 'ones', to: 'oʊ̯nz', next: ['#word'] },
    { from: 'oped', to: 'oʊ̯pt', next: ['#word'] },
    { from: 'opes', to: 'oʊ̯ps', next: ['#word'] },
    { from: 'ored', to: 'ɔɹd', next: ['#word'] },
    { from: 'ores', to: 'ɔɹz', next: ['#word'] },
    { from: 'osed', to: 'oʊ̯st', next: ['#word'] },
    { from: 'oses', to: 'oʊ̯sɪs', next: ['#word'] },
    { from: 'oted', to: 'oʊ̯tɪd', next: ['#word'] },
    { from: 'otes', to: 'oʊ̯ts', next: ['#word'] },
    { from: 'oved', to: 'oʊ̯vd', next: ['#word'] },
    { from: 'oves', to: 'oʊ̯vz', next: ['#word'] },
    { from: 'owed', to: 'oʊ̯d', next: ['#word'] },
    { from: 'owes', to: 'oʊ̯z', next: ['#word'] },
    { from: 'oxed', to: 'ɑkst', next: ['#word'] },
    { from: 'oxes', to: 'ɑksɪz', next: ['#word'] },
    { from: 'ozed', to: 'oʊ̯zd', next: ['#word'] },
    { from: 'ozes', to: 'oʊ̯zɪz', next: ['#word'] },
    // u -> u
    { from: 'ubed', to: 'ubd', next: ['#word'] },
    { from: 'ubes', to: 'ubz', next: ['#word'] },
    { from: 'uced', to: 'ust', next: ['#word'] },
    { from: 'uces', to: 'usɪz', next: ['#word'] },
    { from: 'uded', to: 'udɪd', next: ['#word'] },
    { from: 'udes', to: 'udz', next: ['#word'] },
    { from: 'ufed', to: 'uft', next: ['#word'] },
    { from: 'ufes', to: 'ufs', next: ['#word'] },
    { from: 'uged', to: 'ud͡ʒd', next: ['#word'] },
    { from: 'uges', to: 'ud͡ʒɪz', next: ['#word'] },
    { from: 'ujed', to: 'ud͡ʒd', next: ['#word'] },
    { from: 'ujes', to: 'ud͡ʒɪz', next: ['#word'] },
    { from: 'uked', to: 'ukt', next: ['#word'] },
    { from: 'ukes', to: 'uks', next: ['#word'] },
    { from: 'uled', to: 'uɫd', next: ['#word'] },
    { from: 'ules', to: 'uɫz', next: ['#word'] },
    { from: 'umed', to: 'umd', next: ['#word'] },
    { from: 'umes', to: 'umz', next: ['#word'] },
    { from: 'uned', to: 'und', next: ['#word'] },
    { from: 'unes', to: 'unz', next: ['#word'] },
    { from: 'uped', to: 'upt', next: ['#word'] },
    { from: 'upes', to: 'ups', next: ['#word'] },
    { from: 'ured', to: 'ɜɹd', next: ['#word'] },
    { from: 'ures', to: 'ɜɹz', next: ['#word'] },
    { from: 'used', to: 'uzd', next: ['#word'] },
    { from: 'uses', to: 'uzɪs', next: ['#word'] },
    { from: 'uted', to: 'utɪd', next: ['#word'] },
    { from: 'utes', to: 'uts', next: ['#word'] },
    { from: 'uved', to: 'uvd', next: ['#word'] },
    { from: 'uves', to: 'uvz', next: ['#word'] },
    { from: 'uxed', to: 'ukst', next: ['#word'] },
    { from: 'uxes', to: 'uksɪz', next: ['#word'] },
    { from: 'uzed', to: 'uzd', next: ['#word'] },
    { from: 'uzes', to: 'uzɪz', next: ['#word'] },
    // y -> aɪ̯
    { from: 'ybed', to: 'aɪ̯bd', next: ['#word'] },
    { from: 'ybes', to: 'aɪ̯bz', next: ['#word'] },
    { from: 'yced', to: 'aɪ̯st', next: ['#word'] },
    { from: 'yces', to: 'aɪ̯sɪz', next: ['#word'] },
    { from: 'yded', to: 'aɪ̯dɪd', next: ['#word'] },
    { from: 'ydes', to: 'aɪ̯dz', next: ['#word'] },
    { from: 'yfed', to: 'aɪ̯ft', next: ['#word'] },
    { from: 'yfes', to: 'aɪ̯fs', next: ['#word'] },
    { from: 'yged', to: 'aɪ̯d͡ʒd', next: ['#word'] },
    { from: 'yges', to: 'aɪ̯d͡ʒɪz', next: ['#word'] },
    { from: 'yjed', to: 'aɪ̯d͡ʒd', next: ['#word'] },
    { from: 'yjes', to: 'aɪ̯d͡ʒɪz', next: ['#word'] },
    { from: 'yked', to: 'aɪ̯kt', next: ['#word'] },
    { from: 'ykes', to: 'aɪ̯ks', next: ['#word'] },
    { from: 'yled', to: 'aɪ̯ɫd', next: ['#word'] },
    { from: 'yles', to: 'aɪ̯ɫz', next: ['#word'] },
    { from: 'ymed', to: 'aɪ̯md', next: ['#word'] },
    { from: 'ymes', to: 'aɪ̯mz', next: ['#word'] },
    { from: 'yned', to: 'aɪ̯nd', next: ['#word'] },
    { from: 'ynes', to: 'aɪ̯nz', next: ['#word'] },
    { from: 'yped', to: 'aɪ̯pt', next: ['#word'] },
    { from: 'ypes', to: 'aɪ̯ps', next: ['#word'] },
    { from: 'yred', to: 'aɪ̯ɝd', next: ['#word'] },
    { from: 'yres', to: 'aɪ̯ɝz', next: ['#word'] },
    { from: 'ysed', to: 'aɪ̯st', next: ['#word'] },
    { from: 'yses', to: 'aɪ̯sɪz', next: ['#word'] },
    { from: 'yted', to: 'aɪ̯tɪd', next: ['#word'] },
    { from: 'ytes', to: 'aɪ̯ts', next: ['#word'] },
    { from: 'yved', to: 'aɪ̯vd', next: ['#word'] },
    { from: 'yves', to: 'aɪ̯vz', next: ['#word'] },
    { from: 'yxed', to: 'ɪkst', next: ['#word'] },
    { from: 'yxes', to: 'ɪksɪz', next: ['#word'] },
    { from: 'yzed', to: 'aɪ̯zd', next: ['#word'] },
    { from: 'yzes', to: 'aɪ̯zɪz', next: ['#word'] },

    // run before the next batch
    { from: 'gu', to: 'ɡ', next: ['vowel'] },
    { from: 'qu', to: 'kw' }, { from: 'q', to: 'k' },

    // combos with vowels
    { from: 'eigh', to: 'eɪ̯' },
    { from: 'igh', to: 'aɪ̯' },
    { from: 'ough', to: 'ɑ' },
    { from: 'ai', to: 'eɪ̯' }, { from: 'ay', to: 'eɪ̯' },
    { from: 'au', to: 'aʊ̯' },
    { from: 'ea', to: 'i' },
    { from: 'ee', to: 'i' },
    { from: 'ei', to: 'eɪ̯' }, { from: 'ey', to: 'eɪ̯' },
    { from: 'eu', to: 'u' },
    { from: 'ew', to: 'u' },
    { from: 'ers', to: 'ɝz', next: ['#word'] },
    { from: 'er', to: 'ɝ', next: ['#word'] },
    { from: 'obia', to: 'oʊ̯biə', next: ['#word'] },
    { from: 'ia', to: 'iə', next: ['#word'] },
    { from: 'ia', to: 'aɪə' },
    { from: 'oa', to: 'oʊ̯' },
    { from: 'oe', to: 'oʊ̯' },
    { from: 'oi', to: 'ɔɪ̯' }, { from: 'oy', to: 'ɔɪ̯' },
    { from: 'oo', to: 'u' },
    { from: 'ou', to: 'aʊ̯' },
    { from: 'ow', to: 'oʊ̯' },
    { from: 'ua', to: 'wa' },
    { from: 'ui', to: 'uɪ' },
    { from: 'le', to: 'əɫ', previous: ['consonant'], next: ['#word'] },
    { from: 'tion', to: 'ʃən' },
    { from: 'tions', to: 'ʃənz', next: ['#word'] },
    { from: 'ie', to: 'i', previous: ['consonant'], next: ['#word'] },
    { from: 'ied', to: 'aɪ̯d', next: ['#word'] },
    { from: 'ies', to: 'aɪ̯z', next: ['#word'] },

    // x handled before vowels since it's like two consonants, not one
    { from: 'x', to: 'z', previous: ['#word'] },
    { from: 'x', to: 'ks' },

    // V(CV) -> "long" vowel
    { from: 'a', to: 'eɪ̯', next: { seq: [':consonant', ':vowel'] } },
    { from: 'e', to: 'i', next: { seq: [':consonant', ':vowel'] } },
    { from: 'i', to: 'aɪ̯', next: { seq: [':consonant', ':vowel'] } },
    { from: 'o', to: 'oʊ̯', next: { seq: [':consonant', ':vowel'] } },
    { from: 'u', to: 'u', next: { seq: [':consonant', ':vowel'] } },
    { from: 'y', to: 'aɪ̯', next: { seq: [':consonant', ':vowel'] } },
    // remove silent e
    { from: 'e', to: 'i', previous: { seq: ['#word', ':consonant'] }, next: ['#word'] },
    { from: 'e', to: '', previous: ['consonant'], next: ['#word'] },

    // if it's not a diphthong or long, assume it's short
    { from: 'a', to: 'æ' },
    { from: 'e', to: 'ɛ' },
    { from: 'i', to: 'ɪ' },
    { from: 'o', to: 'ɑ' },
    { from: 'u', to: 'ə' },

    // double consonants
    { from: 'bb', to: 'b' },
    { from: 'dd', to: 'd' },
    { from: 'ff', to: 'f' },
    { from: 'gg', to: 'ɡ' },
    { from: 'kk', to: 'k' },
    { from: 'll', to: 'ɫ' },
    { from: 'mm', to: 'm' },
    { from: 'nn', to: 'n' },
    { from: 'pp', to: 'p' },
    { from: 'rr', to: 'ɹ' },
    { from: 'ss', to: 's' },
    { from: 'tt', to: 't' },
    { from: 'vv', to: 'v' },
    // consonant combos
    { from: 'schn', to: 'ʃn', previous: ['#word'] },
    { from: 'sch', to: 'sk', previous: ['#word'] },
    { from: 'chr', to: 'kɹ', previous: ['#word'] },
    { from: 'tch', to: 't͡ʃ' }, { from: 'ch', to: 't͡ʃ' },
    { from: 'ck', to: 'k' },
    { from: 'kn', to: 'n', previous: ['#word'] },
    { from: 'mc', to: 'mək', previous: ['#word'] },
    { from: 'ng', to: 'ŋ' },
    { from: 'ph', to: 'f' },
    { from: 'ps', to: 's', previous: ['#word'] },
    { from: 'rh', to: 'ɹ', previous: ['#word'] },
    { from: 'sh', to: 'ʃ' },
    { from: 'sm', to: 'zəm', next: ['#word'] },
    { from: 'th', to: 'θ' },
    { from: 'wh', to: 'h', previous: ['#word'], next: 'u' },
    { from: 'wh', to: 'w', previous: ['#word'] },
    { from: 'zh', to: 'ʒ' },
    { from: 'zz', to: 'ts' },
    { from: 'sz', to: 'ʃ' }, { from: 'cz', to: 't͡ʃ' },

    // single consonants (x handled earlier)
    { from: 'c', to: 'k' }, // might have been softened earlier
    { from: 'g', to: 'ɡ' }, // might have been softened earlier
    { from: 'j', to: 'd͡ʒ' },
    { from: 'l', to: 'ɫ' },
    { from: 'r', to: 'ɹ' },
    { from: 'y', to: 'i', next: ['#word'] },
    { from: 'y', to: 'ɪ', previous: ['consonant'], next: ['consonant'] },
    { from: 'y', to: 'j' },

    // do simple substitutions for ascii look-alikes
    { from: 'à', to: 'a' },
    { from: 'á', to: 'a' },
    { from: 'â', to: 'a' },
    { from: 'ã', to: 'ã' },
    { from: 'ä', to: 'ä' },
    { from: 'å', to: 'å' },
    { from: 'ā', to: 'aː' },
    { from: 'è', to: 'e' },
    { from: 'é', to: 'e' },
    { from: 'ê', to: 'e' },
    { from: 'ë', to: 'ë' },
    { from: 'ì', to: 'i' },
    { from: 'í', to: 'i' },
    { from: 'î', to: 'i' },
    { from: 'ï', to: 'ï' },
    { from: 'ñ', to: 'ɲ' },
    { from: 'ò', to: 'o' },
    { from: 'ó', to: 'o' },
    { from: 'ô', to: 'o' },
    { from: 'õ', to: 'õ' },
    { from: 'ö', to: 'ö' },
    { from: 'ō', to: 'o' },
    { from: 'ù', to: 'u' },
    { from: 'ú', to: 'u' },
    { from: 'û', to: 'u' },
    { from: 'ü', to: 'ü' },
    { from: 'ý', to: 'y' },
    { from: 'þ', to: 'θ' },
    { from: 'ÿ', to: 'ÿ' },
    // and other symbols that might need interpretation
    { from: 'ą', to: 'a' },
    { from: 'ň', to: 'ɲ' },
    { from: 'š', to: 'ʃ' },
  ],

  stressRule: { default: 1, toCheck: [] },
}
